module.exports = __webpack_public_path__ + "static/human.7e81b65e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/human.jpg
// module id = 125
// module chunks = 35783957827783 126955526379009